import { render } from "./Slideshow.vue?vue&type=template&id=64019204&scoped=true"
import script from "./Slideshow.vue?vue&type=script&lang=js"
export * from "./Slideshow.vue?vue&type=script&lang=js"

import "./Slideshow.vue?vue&type=style&index=0&id=64019204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64019204"]])

export default __exports__